import { useEffect, useLayoutEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let id: NodeJS.Timer;
    if (delay !== null) {
      id = setInterval(() => {
        savedCallback.current();
      }, delay);
    }
    return () => {
      if (id) {
        clearInterval(id);
      }
    };
  }, [delay]);
}
